import ZJApp from '../../../../app'

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
    service: 'EnvironmentService',
    controller: 'EnMonitoringRecords'
};
const methods = [
    'GetEnMonitoringRecords'
];

const factory = (Fun) => {
    utils.extend(Fun.prototype, info)
    methods.forEach(path => {
        Fun.prototype[path] = function (data) {
            return this.post(path, data)
        }
    })
};

const EnvironmentApi = ZJApi.defineNewApi('EnvironmentApi', factory);

export default EnvironmentApi;